// Autrona Acoustic Computer Program: Pluie
// Une première expérience

import * as main from '../main.js';
import * as screen from '../kernel/screen.js';
import * as audio from '../kernel/audio.js';

// Variables
let keyBoardResponsive = false;
let prompt;
let userName;
let nextPart = part1;
let rainTrack;
let exitCallback;

// Initialize module
function init() {
}

function run(exitCb) {
    exitCallback = exitCb;
    prompt = ''; // Reset
    resetScreen();

    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500, '!s:col-green', 'rat34-a> ',
        3000, '!t:Votre nam §§§om ?:00', 500, '!n',
        100, '> ',
    ];
    screen.sequence(seq, () => {
        main.soundEffect('question');
        enablePrompt();
    });

    document.addEventListener('keydown', handleKeyDowns);
    document.addEventListener('keyup', handleKeyUps);
}

// General keydown event callback
function handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    keyStroke(e.key, 'down');
}

// keyup event callback
function handleKeyUps(e) {
    keyStroke(e.key, 'up');
}

function keyStroke(key, state) {
    if (state == 'down' && keyBoardResponsive) {
        switch (key) {
            case 'Backspace':
                if (prompt.length) {
                    // Remove last keystroke from command line on screen
                    screen.backspace();
                    // Remove last keystroke from command line
                    prompt = prompt.slice(0, -1);
                }
                break;
            case 'Enter':
                main.soundEffect('validate');
                keyBoardResponsive = false;
                screen.newLine();
                nextPart();
                break;
            default:
                if (key.length == 1) {
                    // Add keystroke to screen buffer
                    screen.append(key);
                    // Add keystroke to command line
                    prompt += key;
                }
        }
    }
}

function enablePrompt() {
    prompt = '';
    screen.cursor();
    keyBoardResponsive = true;
}

function resetScreen() {
    screen.clear();
    screen.insert(' AutronaTerm v2.5 - 802.11                                     ', 'col-red', 'col-bg-red');
    screen.pinCurrentLine();
    screen.newLine();
    screen.newLine();
}

function part1() {
    nextPart = part2;
    userName = prompt;

    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500, '!s:col-green', 'rat34-a> ', 500, `!t:Bonjour ${userName} !:00`, '!n',
        500, '!s:col-green', '', 500, '!t:Je suis très content de vous retrouver sur le Terminal.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Ça doit bien faire quelques heures que l’on ne s’est pas parlé.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Comment vous al:00', '!h:<span class="col-dark-red">&lt;!@&gt;</span>', '!n',
        100, '!s:italic', '!s:col-dark-red', '<remote connection error>', '!n',
        50, '!s:col-dark-red', 'Hit [ENTER] to reconnect', '!n',
        100, '> ',
    ];
    screen.sequence(seq, () => {
        main.soundEffect('error');
        enablePrompt();
    });
}

function part2() {
    nextPart = part3;
    resetScreen();

    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500, '!s:col-green', 'rat34-a> ', 500, '!t:Hmm...:00', '!n',
        750, '!s:col-green', '', 500, '!t:navré.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:attendez.:00', '!n',
        5000, '!s:col-green', '', 500, '!t:Juste un instant.:00', '!n',
        5000, '!s:col-green', '', 500, '!t:Vous êtes là ?:00', '!n',        
        500, 'Oui [1] Mouaih [2] > ',       
    ];
    screen.sequence(seq, () => {
        main.soundEffect('question');
        enablePrompt();
    });
}

function part3() {
    nextPart = part4;
    // TODO: Remap main.backgroundTrack loopStart and loopEnd to begin ramp to rainy loop
    //       → main.setLoopMarkers(loopStart, loopEnd)
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500, '!s:col-green', 'rat34-a> ', 500, `!t:Navré, navré ${userName}.:00`, '!n',
        500, '!s:col-green', '', 500, '!t:Je sais c\'est pénible mais j\'ai:00', '!n',
        750, '!s:col-green', '', 500, '!t:j\'ai un petit problème logistique.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Attendez.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Voilà !:00', '!n',
        750, '!s:col-green', '', 500, '!t:J’ai un petit problème logistique... il pleut sur le Terminal...:00', '!n',
        500, '!s:col-green', '', 500, '!t:C’est... c\'est un Terminal extérieur.:00','!n',
        500, '!s:col-green', '', 500, '!t:J\'essaie de le couvrir avec une bâche tout en vous parlant.:00', '!n',
        750, '!s:col-green', '', 500, '!t:Je vous reçois mais j\'ai peur de ne plus pouvoir utiliser le clav:00', '!h:<span class="col-dark-red">&lt;!@&gt;</span>', '!n',
        4000, '!s:col-green', '', 500, '!t:Je disais j\'ai peur d:00', '!h:<span class="col-dark-red">&lt;!@&gt;</span>', '!n',
        500, '!s:italic', '!s:col-dark-red', '<remote connection error>', '!n',
        50, '!s:col-dark-red', 'Hit [ENTER] to reconnect', '!n',
        100, '> ',
    ];
    screen.sequence(seq, () => {
        main.soundEffect('error');
        enablePrompt();
    });

    // Lancer la pluie avec un lent fade in
    const rainCrossTime = 120;
    rainTrack = audio.buffers.play('rain', {
        loop: true,
        loopStart: 0.380,
        loopEnd: 11.121,
    }).fadeTo(rainCrossTime, -18, -90, 'expo');

    main.backgroundTrack.fade(rainCrossTime, -18, false, 'expo');
    setTimeout(() => {
        main.backgroundTrack.fade(rainCrossTime, -90, true, 'expo');
    }, rainCrossTime * 1000);
}

function part4() {
    nextPart = part5;
    resetScreen();

    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500, '!s:col-green', 'rat34-a> ', 500, '!t:Merci de vous être reconnecté pour qu\'on puie continuer à e parler.:00', '!n',
        750, '!s:col-green', '', 500, '!t:c\'et vraiment très gentil:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Vou ête adorable. Vraiment.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Bien, je vou écoute !:00', '!n',
        500, '!s:col-green', '', 500, '!t:Que pui-je faire p:00', '!h:<span class="col-dark-red">&lt;!@&gt;</span>', '!n',
        100, '!s:italic', '!s:col-dark-red', '<remote connection error>', '!n',
        50, '!s:col-dark-red', 'Hit [ENTER] to reconnect', '!n',
        100, '> ',
    ];
    screen.sequence(seq, () => {
        main.soundEffect('error');
        enablePrompt();
    });
}

function part5() {
    nextPart = part6;
    resetScreen();

    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500, '!s:col-green', 'rat34-a> ', 500, '!t:Merci à nouveau.:00', '!n',
        500, '!s:col-green', '', 500, '!t:Pffffffffffff cette pluie... et ce goutte ur le clavier.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Je ui déolé de vou faire endurer ça !:00', '!n',
        750, '!s:col-green', '', 500, '!t:Il pleut ur le clavier, je ne ai pa i vou recevez tou me texte.:00', '!n',
        750, '!s:col-green', '', 500, '!t:Quelle et la lettre qui manque ?:00', '!n',
        100, '> ',
    ];
    screen.sequence(seq, () => {
        main.soundEffect('question');
        enablePrompt();
    });
}

function part6() {
    if (prompt === 's') {
        part9();
    } else {
        nextPart = part7;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500, '!s:col-green', 'rat34-a> ', 500, '!t:Non, je ne croi pa que ce oit celle-là...:00', '!n',
            100, '> ',
        ];
        screen.sequence(seq, () => {
            main.soundEffect('question');
            enablePrompt();
        });
    }
}

function part7() {
    if (prompt === 's') {
        part9();
    } else {
        nextPart = part8;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500, '!s:col-green', 'rat34-a> ', 500, '!t:Non vraiment, ce n’et pa la bonne.:00', '!n',
            100, '> ',
        ];
        screen.sequence(seq, () => {
            main.soundEffect('question');
            enablePrompt();
        });
    }
}

function part8() {
    if (prompt === 's') {
        part9();
    } else {
        nextPart = part9;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500, '!s:col-green', 'rat34-a> ', 500, '!t:Eco tez ! C’et pa grave. Je vai me débroiller an...:00', '!n',
        ];
        screen.sequence(seq, () => {
            nextPart();
        });
    }
}

function part9() {
    nextPart = part10;
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        1000, '!s:col-green', 'rat34-a> ', 500, '!t:Merde !:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Je croi qe j’ai encore n problème avec ne atre lettre:00', '!n',
        3000, '!s:col-green', '', 500, '!t:Attendez.:00', '!n',
        1000, '!s:col-green', '', 500, '!t:Je revien:00', '!n',
        2000, '!s:italic', '!s:col-dark-yellow', '<remote host on hold>', '!n',
        100, '!s:italic', '!s:col-dark-yellow', 'Please wait for remote host', '!t:....................:1000', '!n',
        500, '!s:col-green', 'rat34-a> ', 500, '!t:Voilà. Vo ête là ? Je croi qe j’ai trové ne oltion.:00', '!n', 
        500, '!s:col-green', '', 500, '!t:Mai vo devez d’abord l’accepter:00', '!n',
        500, 'Accepter [1] Refuser [2] > ',
    ];
    screen.sequence(seq, () => {
        main.soundEffect('question');
        enablePrompt();
    });
}

function part10() {
    if (prompt === '1') {
        part12();
    } else {
        nextPart = part11;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500, '!s:col-green', 'rat34-a> ', 500, '!t:N\'ayez pa per ! Vo ne riqez rien.:00', '!n',
            500, 'Accepter tout de même [1] Refuser définitivement [2] > ',
        ];
        screen.sequence(seq, () => {
            main.soundEffect('question');
            enablePrompt();
        });
    }
}

function part11() {
    if (prompt === '1') {
        part12();
    } else {
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500, '!s:col-green', 'rat34-a> ', 500, '!t:Ma foi. Tant pi alor. C\'et trop difficile de comm niqer aini !:00', '!n',
            500, '!s:col-green', 'rat34-a> ', 500, '!t:Recontactez-moi demain i ça ne vo dérange pa. A revoir !:00', '!n',
            2000
        ];
        screen.sequence(seq, () => {
            part15();
        });
    }
}

function part12() {
    nextPart = part13;
    const seq = [
        200, '!s:col-dark-green', '<buffering...>', '!n',
        800, '!s:col-dark-green', '<audio streaming enabled>', '!n',
        1000
    ];
    screen.sequence(seq, () => {
        audio.buffers.play('allo', {
            onended: () => {
                const seq = [
                    500, 'Oui je vous entends [1] Non, rien dans le casque [2] > ',
                ];
                screen.sequence(seq, () => {
                    main.soundEffect('question');
                    enablePrompt();
                });
            }
        });
    });
    
}

function part13() {
    nextPart = part14;
    if (prompt === '2') {
        part11();
    } else {
        audio.buffers.play('vocal', {
            onended: () => {
                const seq = [
                    500, 'Arrêter la pluie [1] > ',
                ];
                screen.sequence(seq, () => {
                    main.soundEffect('success');
                    enablePrompt();
                });
            }
        });
    }
}

function part14() {
    //main.fullFillTask('pluie');
    audio.fadeOutAll(0.5);
    audio.buffers.play('merci', {
        onended: () => {
            part15();
        }
    });
}

function part15() {
    main.soundEffect('disconnected');
    const seq = [
        100, '!s:italic', '!s:col-dark-red', '<remote host disconnected>', '!n',
        100, '!s:italic', '!s:col-dark-red', '<connection closed>', '!n',
    ];
    screen.sequence(seq, () => {
        //exit();
    });
}

function exit() {
    screen.clear();
    exitCallback();
}

export { init, run, keyStroke, exit }
